import apiTeamReport from '../api/team-report.api'

const state = {
  team_report: null,
  tr_list: null
}

const mutations = {
  updateTeamReport (state, tr) {
    state.team_report = tr
  },
  updateTeamReportList (state, data) {
    state.tr_list = data
  }
}

const actions = {
  getTeamReport (context, id) {
    if (state.team_report && state.team_report.id === parseInt(id)) {
      return
    }
    apiTeamReport.api.getTeamReport(id)
      .then(response => {
        context.commit('updateTeamReport', response.data)
      },
      error => {
        console.log('impossible to load team report')
        console.log(error.text())
      })
  },
  getTeamReportListForMatch (context, id) {
    apiTeamReport.api.getTeamReportListForMatch(id)
      .then(response => {
        context.commit('updateTeamReportList', response.data)
      },
      error => {
        console.log('impossible to load team report')
        console.log(error.text())
      })
  },
  purgeTeamReport (context) {
    context.commit('updateTeamReport', null)
  }
}

// getters are functions
const getters = {
  teamReport: state => {
    return state.team_report
  },
  teamReportList: state => {
    return state.tr_list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/team-report.js